import { render, staticRenderFns } from "./DialogsConfirm.vue?vue&type=template&id=5af66f7e&"
import script from "./DialogsConfirm.vue?vue&type=script&lang=js&"
export * from "./DialogsConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports